<astral-accordion appearance="nested" [header]="form.controls['caption'].value" [translateHeader]="false">
  <i astralAccordionHeaderStart [ngClass]="icons"></i>

  <div class="astral-stack-l">
    <section class="astral-section-surface astral-section-surface--compact">
      <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
        <astral-input [control]="form.controls['caption']"></astral-input>
        <astral-select [control]="form.controls['type']" [itemsSource]="roomTypes"></astral-select>
        <astral-input type="number" [control]="form.controls['area']"></astral-input>
      </astral-layout-group>
    </section>

    @if (room.components.length) {
      <div class="astral-stack-m">
        @for (component of room.components; track component) {
          <app-object-component
            [componentCategories]="componentCategories"
            [forms]="form.controls['components']"
            [rootForm]="rootForm"
            [component]="component"
            [rentalObjectId]="rentalObjectId"
            [collection]="room.components"
            [parentIsNew]="component.isNew || room.isNew"
            actionButtonSize="extra-small"
          ></app-object-component>
        }
      </div>
    }

    <div class="astral-form-actions">
      <astral-button
        variant="primary"
        size="extra-small"
        type="button"
        icon="plus"
        labelKey="COMPONENT.ADD_COMPONENT"
        (click)="addComponent()"
      ></astral-button>
      <astral-button
        variant="secondary"
        size="extra-small"
        type="button"
        icon="trash"
        labelKey="ROOM.DELETE_ROOM"
        (click)="delete()"
      ></astral-button>
    </div>
  </div>
</astral-accordion>
